import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00352722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-list" }
const _hoisted_2 = ["aria-label", "aria-current", "onClick", "onKeydown"]
const _hoisted_3 = {
  key: 0,
  class: "team-item__badge"
}
const _hoisted_4 = { class: "team-item__icon" }
const _hoisted_5 = { class: "team-item__body" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { team } from '@/common/basis/root-injector'
import { TeamInfo } from '@/services/team'
import { TeamListShowType } from './team-list.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'team-list',
  props: {
  teamList: {
    type: Array as () => TeamInfo[],
    default: () => [],
  },
  showType: {
    type: String as () => TeamListShowType,
    default: TeamListShowType.own,
  },
},
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit
const { t } = useI18n()

const currentTeam = ref<TeamInfo>()

if (props.showType === TeamListShowType.own) {
  team.currentTeam.subscribe((activeTeam) => {
    currentTeam.value = activeTeam
  })
}

const sortedTeamList = computed(() => {
  if (props.showType !== TeamListShowType.own) {
    return props.teamList
  }
  const activeId = currentTeam.value?.team_id
  if (activeId == null) {
    return props.teamList
  }
  return [...props.teamList].sort((a, b) => {
    if (a.team_id === activeId) return -1
    if (b.team_id === activeId) return 1
    return 0
  })
})

function isSelected (item: TeamInfo) {
  return props.showType === TeamListShowType.own
    && currentTeam.value?.team_id === item.team_id
}

function teamItemAriaLabel (item: TeamInfo) {
  const parts = [item.name, item.role_name].filter(Boolean)
  return parts.join(' · ')
}

function handleSelect (selected: TeamInfo) {
  emits('select', selected)
}

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTeamList.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.team_id,
        class: _normalizeClass(["team-item", {
        'is-selected': isSelected(item),
        'is-invite': __props.showType === _unref(TeamListShowType).invite,
      }]),
        role: "button",
        tabindex: "0",
        "aria-label": teamItemAriaLabel(item),
        "aria-current": isSelected(item) ? 'true' : undefined,
        onClick: ($event: any) => (handleSelect(item)),
        onKeydown: [
          _withKeys(_withModifiers(($event: any) => (handleSelect(item)), ["prevent"]), ["enter"]),
          _withKeys(_withModifiers(($event: any) => (handleSelect(item)), ["prevent"]), ["space"])
        ]
      }, [
        (__props.showType === _unref(TeamListShowType).invite)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('teamPage.invitePending')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CmSvgIcon, {
            name: "assets/icons/team",
            monochrome: "",
            size: 36
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", {
            class: "team-item__name",
            title: item.name
          }, _toDisplayString(item.name), 9, _hoisted_6),
          (item.role_name)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "team-item__role",
                title: item.role_name
              }, _toDisplayString(item.role_name), 9, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ], 42, _hoisted_2))
    }), 128))
  ]))
}
}

})